'use client';

import { CollectionType, UserType } from '@/@types';
import { Dropdown, Icon, Modal } from '@/components/core';
import CollectionCard from '@/components/core/components/molecules/collection-card';
import RestultGrid from '@/components/core/components/molecules/result-grid';
import CollectionForm from '@/components/core/components/organism/collection-form';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react';
import React, { useEffect, useState } from 'react';
import { useUser } from '@/components/context/user';
import { UIComponent } from '@/components/core/components';
import * as styles from './collections.styles';

const sortBy = {
  name: msg`Name`,
  createdAt: msg`Recently created`,
  updatedAt: msg`Recently updated`,
  recommendationCount: msg`Number of recommendations`,
};

const Collections: UIComponent<{ collections: CollectionType[]; profile: UserType }> = ({ collections: propsCollections, profile }) => {
  const { user } = useUser();
  const [collections, setCollections] = useState<CollectionType[]>(propsCollections || []);
  const [newCollection, setNewCollection] = useState(false);
  const [sortDropdown, setSortDropdown] = useState(false);
  const [sortedBy, setSortedBy] = useState<keyof typeof sortBy>('updatedAt');
  const { i18n } = useLingui();

  useEffect(() => {
    setCollections(propsCollections || []);
  }, [propsCollections]);
  return (
    <div className={styles.root}>
      <div className={styles.toolbar}>
        <span />
        <Dropdown
          align="right"
          open={sortDropdown}
          onOpen={() => {
            return setSortDropdown(true);
          }}
          onClose={() => {
            return setSortDropdown(false);
          }}
        >
          <Dropdown.Trigger>
            <span className="flex items-center gap-2 cursor-pointer">
              {i18n._(sortBy[sortedBy])} <Icon name="sort" />
            </span>
          </Dropdown.Trigger>
          <Dropdown.Content className="min-w-[250px]">
            {Object.entries(sortBy).map(([key, value]) => {
              return (
                <Dropdown.Item
                  key={key}
                  onClick={() => {
                    setSortedBy(key as any);
                    setSortDropdown(false);
                  }}
                >
                  {i18n._(value)}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Content>
        </Dropdown>
      </div>
      <RestultGrid minCols={2}>
        {collections
          .concat([])
          .sort((a, b) => {
            if (typeof a[sortedBy] === 'string' && typeof b[sortedBy] === 'string') {
              return a[sortedBy].toLowerCase() > b[sortedBy].toLowerCase() ? 1 : -1;
            }
            return a[sortedBy]! > b[sortedBy]! ? -1 : 1;
          })
          .map((collection) => {
            return <CollectionCard vertical collection={collection} key={collection.id} />;
          })}
        {user?.id === profile.id && (
          <CollectionCard
            collection={{ id: '', name: i18n._(msg`New Collection`), images: [] }}
            as="span"
            role="button"
            vertical
            onClick={() => {
              setNewCollection(true);
            }}
          />
        )}
      </RestultGrid>
      <Modal
        open={newCollection}
        onClose={() => {
          setNewCollection(false);
        }}
      >
        <Modal.Card>
          <CollectionForm
            onSave={(collection) => {
              setCollections((cols) => {
                return cols.concat({
                  ...collection,
                  recommendationCount: 0,
                  owner: profile,
                });
              });
              setNewCollection(false);
            }}
          />
        </Modal.Card>
      </Modal>
    </div>
  );
};

export default Collections;
